import { trackEvent } from 'utils'

//@ts-ignore
export const isDesktop = (window.isTauri || false) as boolean

let sessionStartTime: number = 0

export function startSessionTracking() {
  sessionStartTime = Date.now()
}

export function endSessionTracking(properties = {}) {
  const duration = (Date.now() - sessionStartTime) / 1000
  trackEvent('Session Ended', { ...properties, duration })
}

export function addLayoutTag(tag: string) {
  return {
    'data-layout': tag,
  }
}

export const EXPLORER_DIMENSIONS = {
  layout: {
    height: 704,
    width: 1000,
    get ratio() {
      return this.width / this.height
    },
  },
  traits: {
    height: 450,
    width: 1200,
    get ratio() {
      return this.width / this.height
    },
  },
}
